import React from 'react';
import Autocomplete from 'react-autocomplete';
import { StatDetails } from './../../../lib/StatHelpers.js';

class TagInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
  }
  changeValue = (e) => {
    this.setState({
      value: e.target.value,
    });
  }
  selectValue = (val) => {
    this.setState({ value: val });
    this.props.selectVal(val);
  }
  render() {
    return (
      <Autocomplete
        getItemValue={item => item.id}
        items={StatDetails.Female.tags.values}
        renderItem={(item, isHighlighted) => (
          <div style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
            {item.title}
          </div>
        )}
        value={this.state.value}
        onChange={this.changeValue}
        onSelect={this.selectValue}
      />
    );
  }
}

export default TagInput;
